import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';
import BrandLogo from '../../../assets/images/logo.png';
import { Menu, LogOut, User } from 'lucide-react';
import { Offcanvas, Badge } from 'react-bootstrap';
import Sidebar from '../Sidebar/Sidebar';
import { useAuth } from '../../../contexts/AuthContext';

const Header = () => {
    const [show, setShow] = React.useState(false);
    const navigate = useNavigate();
    const { logout, user } = useAuth();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <header className="header d-flex justify-content-between align-items-center p-3">
            <div className="hamburger" onClick={handleShow}>
                <Menu size={24} />
            </div>
            <div className="logo">
                <img src={BrandLogo} alt="Brand Logo" />
            </div>
            <div className="d-flex align-items-center gap-3">
                {user && (
                    <div className="d-flex align-items-center gap-2">
                        <User size={18} />
                        <span className="text-sm">{user.name}</span>
                        {user.role && (
                            <Badge bg="primary" className="text-xs">{user.role}</Badge>
                        )}
                    </div>
                )}
                <div className="logout d-flex align-items-center" onClick={handleLogout} style={{ cursor: 'pointer' }}>
                    <LogOut size={20} className="me-2" />
                    <span>Logout</span>
                </div>
            </div>

            {/* Offcanvas Sidebar */}
            <Offcanvas show={show} onHide={handleClose} placement="start">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Sidebar closeOffCanvas={handleClose} />
                </Offcanvas.Body>
            </Offcanvas>
        </header>
    );
};

export default Header;

